import { render, staticRenderFns } from "./Bando31Fase3.vue?vue&type=template&id=26144fbc&scoped=true"
import script from "./Bando31Fase3.vue?vue&type=script&lang=js"
export * from "./Bando31Fase3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26144fbc",
  null
  
)

export default component.exports